
const state = {
  campaign_quote_template_id: undefined,
  footer: undefined,
  header: undefined,
  hide_dates: false,
  hide_prices: false,
  id: null,
  locked: false,
  options: {},
  show_subtotal: false,
  sort: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'campaign_quote_template_id' },
  { key: 'title' },
]

export default state
